import Quantum1 from '../../../Media/Ruko Paramount/Quantum/Quantum (1).webp'
import Quantum2 from '../../../Media/Ruko Paramount/Quantum/Quantum (2).webp'

const Quantumimages =[
Quantum1,Quantum2
]

export default Quantumimages;
